export default "__VITE_ASSET__2d21fe47__"